import React, { useEffect, useState } from "react";
import { Box, Typography, CircularProgress } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { fetchRequestCallbackList } from "../../Adapters/ApiAdapter";
import { toast, ToastContainer } from "react-toastify";

const ListRequestCallbacks = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadData = async () => {
      try {
        const response = await fetchRequestCallbackList();
        setRows((response.data || []).sort(
          (a, b) => new Date(b.created_at) - new Date(a.created_at)
        )
        );
      } catch (err) {
        toast.error("Failed to load appointment requests.");
      } finally {
        setLoading(false);
      }
    };
    loadData();
  }, []);

  const columns = [
    { field: "id", headerName: "ID", width: 70 },
    { field: "patient_name", headerName: "Patient Name", width: 180 },
    {
      field: "contact_number",
      headerName: "Contact",
      width: 160,
      valueGetter: (params) =>
        `${params.row.country_code || ""} ${params.row.contact_number}`,
    },
    { field: "email", headerName: "Email", width: 200 },
    { field: "specialty_name", headerName: "Specialty", width: 150 },
    { field: "doctor_name", headerName: "Doctor", width: 150 },
    { field: "appointment_date", headerName: "Appointment Date", width: 150 },
    { field: "message", headerName: "Message", width: 250 },
    {
      field: "created_at",
      headerName: "Created At",
      width: 180,
      renderCell: (params) =>
        new Date(params.value).toLocaleString("en-IN"),
    },
  ];

  return (
    <Box m="20px">
      <ToastContainer />
      <Typography variant="h4" gutterBottom>
        Appointment Request List
      </Typography>
      {loading ? (
        <CircularProgress />
      ) : (
        <DataGrid
          rows={rows}
          columns={columns}
          autoHeight
          getRowId={(row) => row.id}
        />
      )}
    </Box>
  );
};

export default ListRequestCallbacks;
